import { Component, Input } from '@angular/core';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { AppConfig } from '../../../../app/app.config';

@Component({
  selector: 'implementer-empty-state-component',
  templateUrl: 'implementer-empty-state-component.html'
})
export class ImplementerEmptyStateComponent {
  @Input() snapshotSummary: ImplementerSnapshotSummary;
  @Input() loading: boolean;

  config = AppConfig.settings;

  constructor() {
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-empty-state/implementer-empty-state-component/implementer-empty-state-component.ts